module.exports = __webpack_public_path__ + "media/images/instructions/aws-iam-roles-4-attach-policy-0fef514f27e2c5ce4bdbf442d7e55c86.png";